export default __webpack_public_path__ + "static/headstand-bodycenter-3-ed876cf7b65c43c530d0d63d759e8cae.jpg";